<template>
  <div>


    <div class="wrapper wrapper-full-page login-wrapper">
      <div class="full-page login-page" data-color=""
           data-image="static/img/background/background-2.jpg">
        <div class="content">
          <div class="container">
              <div class="login-box">
                <div class="card-header text-center">
                    <a href="//taptasty.com"><img src="/static/img/logo.png" class="logo"></a>
                </div>
                <div>If you were not redirected, please click this <a :href="apiUrl + '/login'">Link</a> in order to get to the TapTasty Dashboard</div>
              </div>
          </div>
        </div>
        <div class="full-page-background" ></div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import Vuex from 'vuex'
  Vue.use(Vuex)

  export default {
    data () {
      return {
        apiUrl: process.env.API_BASE_URL
      }
    },
    created () {
      this.saveWoltCode()
    },
    methods: {
      saveWoltCode () {
        const params = this.$route.query

        var data = {
          payload: params
        }

        this.apiRequest('/client-api/wolt/dashboard-callback', 'POST', data, (response) => {
          this.$router.push('/login')
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Wolt.vue